// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"headline-m__wrapper__2SLf5","headline":"headline-m__headline__3jOQi","dark":"headline-m__dark__30lii","light":"headline-m__light__3uk5Q"};